import React, { useEffect } from 'react'
import { Backdrop, Panel, Header, Title, CloseButton, Content } from './style'
import { CloseIcon } from 'shared-ui/assets'
import LazyImage from '../../components/LazyImage'
import { useTheme } from 'styled-components'

const RightSidePanel = ({
  open,
  title,
  onClose,
  width,
  children,
  showClose = true,
  actions,
  left,
  padding,
  isNotification
}) => {
  useEffect(() => {
    if (!open) return
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose && onClose()
    }
    document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [open, onClose])
  const theme = useTheme()

  if (!open) return null

  const isNotificationPanel =
    isNotification ||
    (typeof title === 'string' &&
      title.toLowerCase() === 'notifications') ||
    (typeof title === 'string' &&
      title.toLowerCase().includes('notification') &&
      !title.toLowerCase().includes('filter'))

  const panelPadding =
    padding || (isNotificationPanel ? '32px 3px 10px 3px' : undefined)

  return (
    <Backdrop onClick={onClose}>
      <Panel width={width} padding={panelPadding} onClick={(e) => e.stopPropagation()}>
        <Header>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              paddingLeft: isNotificationPanel ? '32px' : undefined
            }}
          >
            {left}
            {title && <Title>{title}</Title>}
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            {actions}
            {showClose && (
              <CloseButton aria-label="Close" onClick={onClose}>
                <LazyImage
                  src={theme.app.CloseIcon}
                  alt="Close"
                  width={14}
                  height={14}
                />
              </CloseButton>
            )}
          </div>
        </Header>
        <Content>{children}</Content>
      </Panel>
    </Backdrop>
  )
}

export default RightSidePanel
